module.exports = __webpack_public_path__ + "img/Indiana Outline.eff93287.png";